module.exports = __webpack_public_path__ + "static/media/cc.12b2a484.svg";